// 旧 CoffeeScript(paybook.js.coffee)を vanilla ES へ移植。jQuery 依存を撤去 (#2428)。

// 銀行を選ぶと支店プルダウンを AJAX で更新する。銀行 select(.bank-code)の
// change を native で購読し、/banks/branches?code=&name= を JSON で取得して
// 支店 select(Tom Select or 素の select)の options を差し替える
// (旧: <select> ごと replaceWith して bootstrap-select 再初期化)。
const updateBranches = async (bankSelect) => {
  const form = bankSelect.closest("form");
  if (!form) return;
  const branchSelect = form.querySelector("select.branch-code");
  if (!branchSelect) return;

  const name = branchSelect.getAttribute("name") || "";
  const code = bankSelect.value;
  const res = await fetch(
    `/banks/branches?code=${encodeURIComponent(code)}&name=${encodeURIComponent(name)}`,
    { headers: { Accept: "application/json" }, credentials: "same-origin" }
  );
  if (!res.ok) return;
  const options = await res.json(); // [[label, value], ...]

  const ts = branchSelect.tomselect;
  if (ts) {
    ts.clear(true);
    ts.clearOptions();
    ts.addOptions(options.map(([text, value]) => ({ value, text })));
    ts.refreshOptions(false);
  } else {
    branchSelect.innerHTML = "";
    options.forEach(([text, value]) => {
      const opt = document.createElement("option");
      opt.value = value;
      opt.textContent = text;
      branchSelect.appendChild(opt);
    });
  }
};

// data-lazy=true のリンクを、その href を GET した HTML で置き換える(遅延読込)。
const loadLazyLinks = () => {
  document.querySelectorAll("a[data-lazy=true]").forEach(async (a) => {
    const res = await fetch(a.getAttribute("href"), { credentials: "same-origin" });
    if (!res.ok) return;
    const html = await res.text();
    const tmp = document.createElement("template");
    tmp.innerHTML = html.trim();
    a.replaceWith(tmp.content);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("change", (ev) => {
    const bankSelect = ev.target.closest && ev.target.closest("select.bank-code");
    if (bankSelect) updateBranches(bankSelect);
  });

  document.addEventListener("click", (ev) => {
    const trigger = ev.target.closest && ev.target.closest(".remove_hyojunhoshu");
    if (trigger) trigger.closest("tr").remove();
  });

  loadLazyLinks();
});
